import { getCkEditorType, getExtraPlugins } from '../plugins/CkEditor/ckEditorTypes.config';

export default {
    /* eslint-disable no-undef*/
    mounted() {
        const {
                editorId, editorType, language, height, width, autoFocus,
            } = this;
        const ckeditorConfig = {
            toolbar: getCkEditorType(editorType),
            language,
            height,
            width,
            startupFocus: autoFocus,
            mentions: [
                {
                    feed: this.dataFeed,
                    itemTemplate:
                        '<li data-id="{id}"> <figure><img class="photo" src="{profileImageUrl}" ' +
                        'onerror="this.src=\'{fallbackProfileImageUrl}\';"/></figure> ' +
                        '<span> {firstName} {lastName} <small>{chapterName} </small> </span> </li>',
                    outputTemplate: '<a id="{userId}" style="text-decoration: underline;"> <b> @{firstName} {lastName}</b></a>&nbsp;',
                    minChars: 3,
                },
            ],
            extraPlugins: getExtraPlugins(editorType),
        };

        if (CKEDITOR.instances[editorId]) {
            CKEDITOR.instances[editorId].destroy(true);
        }

        CKEDITOR.replace(editorId, ckeditorConfig);
        CKEDITOR.instances[editorId].on('instanceReady', () => {
            CKEDITOR.instances[editorId].setData(this.value);
        });

        CKEDITOR.instances[editorId].on('change', () => {
            const ckeditorData = CKEDITOR.instances[editorId].getData();
            if (ckeditorData !== this.value) {
                this.$emit('input', ckeditorData);
            }
        });
    },
    destroyed() {
        const { editorId } = this;
        if (CKEDITOR.instances[editorId]) {
            if (this.memberMentionsCallback) {
                this.memberMentionsCallback([]);
            }
            CKEDITOR.instances[editorId].destroy(true);
        }
    },

    /* eslint-enable no-undef */
};
